import GraphemeSplitter from 'grapheme-splitter';

export function checkYatLength(emojiStr = '') {
    const grapheme = new GraphemeSplitter();
    return grapheme.splitGraphemes(emojiStr).length;
}
